import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { default as GetStartedList } from './GetStartedList';
import { GetStartedListPosition } from '../enums/GetStartedListPosition';
import { isGetStartedInListViewVisible } from '../selectors/isGetStartedInListViewVisible';
import { isGetStartedInListViewClosed } from '../selectors/isGetStartedInListViewClosed';
import closeGetStartedInListView from '../actions/closeGetStartedInListView';

const styles = require('./GetStartedListInListView.scss');

const GetStartedListInListView = observer(function GetStartedListInListView(props: {
    rowCount: number;
}) {
    const MESSAGE_ROW_COUNT_LIMIT = 20;

    React.useEffect(() => {
        if (!isGetStartedInListViewClosed() && props.rowCount > MESSAGE_ROW_COUNT_LIMIT) {
            closeGetStartedInListView();
        }
    });

    return (
        isGetStartedInListViewVisible() && (
            <GetStartedList
                position={GetStartedListPosition.ListView}
                className={styles.paneWrapper}
            />
        )
    );
});

export default GetStartedListInListView;
